<div class="flex flex-col h-full justify-between">
  <app-header [title]="title">
    <button
      additional-slot
      id="close-modal-button"
      class="btn-primary m-0 flex items-center justify-center w-min p-1"
      (click)="closeModal()"
    >
      <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
    </button>
  </app-header>
  <form [formGroup]="multiSelectSearchForm" class="flex flex-row justify-center items-center">
    <div
      id="multi-select-search-container"
      class="flex w-full items-center justify-between border-2 border-grey-mid border-solid rounded-full cursor-text overflow-hidden m-3 sticky top-3 focus-within:border-primary"
    >
      <input
        id="multi-select-search-input"
        #searchInput
        class="h-min border-none hover:border-none bg-transparent px-4 py-1 text-lg"
        type="text"
        placeholder="Search"
        autofocus
        autocomplete="off"
        minlength="3"
        formControlName="multiSelectSearchInput"
        (keyup)="filterOptions()"
      />
      <ion-icon class="text-lg p-2 text-secondary" name="search-outline"></ion-icon>
    </div>
  </form>
  @if (!!selectLimit) {
    <div class="text-sm italic opacity-60 pl-4">
      Selection limited to {{ selectLimit }} item{{ selectLimit > 1 ? 's' : '' }}.
    </div>
  }
  <div class="flex pb-6 h-full overflow-auto">
    @if (selectOptions.length > 0) {
      <div class="w-full">
        @for (selectOption of selectedList; track selectOption.value) {
          <ion-item id="select-option-{{ selectOption.value }}" lines="none" mode="ios">
            <ion-checkbox
              mode="md"
              class="mr-2"
              (ionChange)="handleSelectionChange($event, selectOption)"
              [checked]="true"
              label-placement="end"
              justify="start"
            >
              <div class="text-sm">{{ selectOption.title }}</div>
            </ion-checkbox>
          </ion-item>
        }
        @for (selectOption of unselectedList; track selectOption.value) {
          <ion-item id="select-option-{{ selectOption.value }}" lines="none" mode="ios">
            <ion-checkbox
              mode="md"
              class="mr-2"
              [disabled]="selectedList.length >= selectLimit"
              (ionChange)="handleSelectionChange($event, selectOption)"
              [checked]="false"
              label-placement="end"
              justify="start"
            >
              <div class="text-sm">{{ selectOption.title }}</div>
            </ion-checkbox>
          </ion-item>
        }
      </div>
    }
    @if (selectOptions.length == 0) {
      <div class="empty-state shadow-none px-10 py-32">
        <h1>
          <ion-icon name="people-outline"></ion-icon>
        </h1>
        <h1>No results</h1>
        <p class="text-sm">Try adjusting your search to find what you're looking for</p>
        <button class="btn-primary mt-10">Clear search</button>
      </div>
    }
  </div>
  <div class="flex gap-2 p-3 w-full border-t-2 border-grey-concrete">
    <button id="multi-select-apply" class="btn-primary text-sm" (click)="applySelection()">Apply</button>
    <button id="multi-select-cancel" class="btn-default text-sm" (click)="closeModal()">Cancel</button>
    <div class="flex w-full items-center justify-end">{{ selectedList.length }} Selected</div>
  </div>
</div>
